import {
    CircularProgress,
    FormControl,
    FormHelperText,
    InputAdornment,
    InputLabel,
    OutlinedInput
} from '@mui/material';
import { useDebounceValue } from '@shared/hooks/useDebounce';
import { I18nStore } from '@tools/i18n/store';
import { injectTSDI } from '@tools/tsdi';
import { observer } from 'mobx-react';
import * as React from 'react';

import { Step2Store } from '../../step-2/store';

export const StudioNameField = observer(() => {
    const { translate } = injectTSDI(I18nStore);
    const { form, suggestDomainName, isDomainSuggestionLoading, domain } =
        injectTSDI(Step2Store);
    const { studioName } = form.$;

    const { value, error } = studioName;

    const debouncedStudioName = useDebounceValue(value, 300);

    React.useEffect(() => {
        void suggestDomainName(debouncedStudioName);
    }, [suggestDomainName, debouncedStudioName]);

    return (
        <FormControl variant="outlined" error={!!error} fullWidth>
            <InputLabel required>{translate('signup.studioname')}</InputLabel>
            <OutlinedInput
                onBlur={() => studioName.validate()}
                onChange={(e) => {
                    studioName.onChange(e.currentTarget.value);
                }}
                label={`${translate('signup.studioname')}*`}
                value={value}
                {...(isDomainSuggestionLoading && {
                    endAdornment: (
                        <InputAdornment position="end">
                            <CircularProgress size={20} color="inherit" />
                        </InputAdornment>
                    )
                })}
                inputProps={{
                    'data-role': 'studio'
                }}
            />
            <FormHelperText error={false}>
                {`${domain}.web.magicline.com`}
            </FormHelperText>
            <FormHelperText>{error || ' '}</FormHelperText>
        </FormControl>
    );
});
